import { SaveRouter } from './../../shared/components';

export type CreateRouterPageProps = {};

const CreateRouterPage: React.FC<CreateRouterPageProps> = () => {
  return <SaveRouter title="Crear Router" />;
};

export default CreateRouterPage;
